import { Class } from './Class/Class';
import ClassLawEnforcement from "../../img/class_lawenforcement.png"

export const LawEnforcement = () => (
    <Class name="Law Enforcement" imgSrc={ClassLawEnforcement}>
        <p>We work with law enforcement agencies on continuing officer education. Courses include take down and submission techniques, self defense, as well as stress relief and meditation. To inquire about our law enforcement training please give us a call to discuss your needs and a personalized program.</p>
    </Class>
);